<script setup lang="ts">
import { type LinkComponent, provideLink } from '../../composables/use-link';
import Toaster from '../toast/toaster.vue';

type Props = {
  /**
   * The host router's link component (RouterLink, NuxtLink) for shared
   * components that render links.
   */
  link: LinkComponent;
};

const props = defineProps<Props>();

provideLink(props.link);
</script>

<template>
  <slot />
  <Toaster />
</template>
